module.exports = {"F3":3.82,"F5":4.89,"V3":3.95,"V5":3.43}


//////////////////
// WEBPACK FOOTER
// ./src/utils/internal-rates.json
// module id = 2320
// module chunks = 0